import React from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaFacebookSquare,
  FaInstagram,
} from "react-icons/fa";
import { Row, Col } from "./components/grid";
import { menuLinks } from "./resources/menu";
import Container from "./components/Container";
import { Link } from "react-router";

function Default() {
  const today = new Date();
  const visibleMenuItems = menuLinks.filter((menuItem) => !menuItem.hidden);
  const clubMenuItem = visibleMenuItems.find((item) => item.key === "club");
  const tournamentsMenuItem = visibleMenuItems.find(
    (item) => item.key === "tournaments",
  );
  const partnersMenuItem = visibleMenuItems.find(
    (item) => item.key === "partners",
  );
  const newsMenuItem = visibleMenuItems.find((item) => item.key === "news");
  const contactMenuItem = visibleMenuItems.find(
    (item) => item.key === "contact",
  );

  return (
    <>
      <div>
        <Container>
          <Row>
            <Col md={12} lg={4} className="address">
              <Row>
                <img
                  src="/logo2.png"
                  alt="logo tt blagnacais"
                  width={134}
                  height={82}
                />
              </Row>
              <Row>
                <FaMapMarkerAlt />
                33 Chemin du Moulin de Naudin
                <br />
                31700 BLAGNAC
              </Row>
              <Row>
                <FaPhoneAlt />
                <a href="tel:0760437114">07 60 43 71 14</a>
              </Row>
              <Row>
                <FaFacebookSquare />
                <a
                  href="https://www.facebook.com/ttblagnacais31"
                  target="_blank"
                  rel="noreferrer"
                >
                  /ttblagnacais31
                </a>
              </Row>
              <Row>
                <FaInstagram />
                <a
                  href="https://www.instagram.com/tt_blagnac_/"
                  target="_blank"
                  rel="noreferrer"
                >
                  /tt_blagnac_
                </a>
              </Row>
            </Col>
            {clubMenuItem && (
              <Col xs={6} lg={2}>
                <strong>Le club</strong>
                <ul>
                  {clubMenuItem.children
                    .filter((menuItem) => !menuItem.hidden)
                    .map((menuItem) => (
                      <li key={menuItem.key}>
                        <Link to={menuItem.url}>{menuItem.label}</Link>
                      </li>
                    ))}
                </ul>
              </Col>
            )}
            {tournamentsMenuItem && (
              <Col xs={6} lg={2}>
                <strong>Compétitions</strong>
                <ul>
                  {tournamentsMenuItem.children
                    .filter((menuItem) => !menuItem.hidden)
                    .map((menuItem) => (
                      <li key={menuItem.key}>
                        <Link to={menuItem.url}>{menuItem.label}</Link>
                      </li>
                    ))}
                </ul>
              </Col>
            )}
            {partnersMenuItem && (
              <Col xs={6} lg={2}>
                <strong>Partenaires</strong>
                <ul>
                  {partnersMenuItem.children
                    .filter((menuItem) => !menuItem.hidden)
                    .map((menuItem) => (
                      <li key={menuItem.key}>
                        <Link to={menuItem.url}>{menuItem.label}</Link>
                      </li>
                    ))}
                </ul>
              </Col>
            )}
            <Col xs={6} lg={2}>
              <>
                <strong>
                  <Link to="/stages-enfants">Stages enfants</Link>
                </strong>
                <br />
                <br />
              </>
              {newsMenuItem && (
                <>
                  <strong>
                    <Link to={newsMenuItem.url}>{newsMenuItem.label}</Link>
                  </strong>
                  <br />
                  <br />
                </>
              )}
              {contactMenuItem && (
                <>
                  <strong>
                    <Link to={contactMenuItem.url}>
                      {contactMenuItem.label}
                    </Link>
                  </strong>
                  <br />
                  <br />
                </>
              )}
              <strong>
                <a
                  href="https://www.calameo.com/mairie-de-blagnac/read/0038439388ffec82b02a2"
                  target="_blank"
                  rel="noreferrer"
                >
                  Charte équipements sportifs
                </a>
              </strong>
            </Col>
          </Row>
        </Container>
      </div>
      <div>
        <Container>
          <Row>
            <Col md={12} lg={3} className="legal-notice">
              <Link to="/mentions-legales">Mentions légales</Link>
            </Col>
            <Col md={12} lg={6} className="copyright">
              © {today.getFullYear()} Tennis de Table Blagnacais. Tous droits
              réservés.
            </Col>
            <Col md={12} lg={3} className="credits">
              Design:{" "}
              <a
                href="https://florencesimonne.fr/"
                target="_blank"
                rel="noreferrer"
              >
                Florence Simonne
              </a>
              <br />
              Développement:{" "}
              <a
                href="https://simon-couderette.com/"
                target="_blank"
                rel="noreferrer"
              >
                Simon Couderette
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export const AppFooter = React.memo(Default);
